import styled from '@emotion/styled';

export const StyledLabel = styled.label`
  font: var(--font-body-m-light);
  color: var(--color-black);
`;
